import React, { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
  TabMenuContainer,
  LoaderContainer,
} from '../SidebarMenu/styles';
import EmailFolderTabDetails from '../SidebarMenu/EmailFolderTabDetails';
import Loader from '../../components/Loader';
import { DESIGN_AREA_FOLDERS_TAB } from '../SidebarMenu/translationValues';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';

const NAMESPACES = ['DESIGN_AREA_FOLDERS_TAB'];

const ComplexEmailFolderTab = props => {
  const { t, CurrentDesign } = props;
  const isLoading = false;

  const editableSelector = useCallback(store => store[CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN], []);
  const [editable] = useArtboardContext(editableSelector, 'ComplexArtboard');

  return (
    <TabMenuContainer>
      {isLoading && (
        <LoaderContainer>
          <Loader />
          <div className="loading-txt">
            {t(
              DESIGN_AREA_FOLDERS_TAB.LOADING_FOLDERS.key,
              DESIGN_AREA_FOLDERS_TAB.LOADING_FOLDERS.value,
            )}
          </div>
        </LoaderContainer>
      )}
      <EmailFolderTabDetails editable={editable} elementType={CurrentDesign === 'document' ? 'emailTemplate' : 'email_block'}/>
    </TabMenuContainer>
  );
}

export default withTranslation(NAMESPACES)(withRouter(ComplexEmailFolderTab));
